// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__20d5s","resendInfoText":"OnGoingPaymentBox_resendInfoText__2W5hD"};